import { createFileRoute } from '@tanstack/react-router';

import DocumentsLinkage from '../../components/DocumentsLinkage/DocumentsLinkage';

export const Route = createFileRoute('/_auth/documents-linkage')({
  component: DocumentsLinkage,
});
